import axios from "./axios";

class MemberRepository {
  get(id) {
    return axios.get(`/memberships?id=${id}`, {}).then((response) => {
      return response.data;
    });
  }

  save(membership) {
    return axios.post(`/memberships`, membership).then((response) => {
      return response.data;
    });
  }
}

export default new MemberRepository();



// WEBPACK FOOTER //
// ./src/data/membership.repository.js